<div class="card  shadow-sm" *ngIf="pricingData" [ngClass]="isMid? 'blueback':'white-back'">
  <div class="card-body">
    <div class="d-flex justify-content-between mb-3">
      <h2 class="card-title">{{isEnglish? pricingData.name : pricingData.nameAr }}</h2>
      <span class="badge bg-white d-flex align-items-center px-2 text-dark" *ngIf="pricingData.isRecommended">
        <app-icon icon="star" size="16px" class="mr-2"></app-icon>
        {{'global.recommended' | translate}}
      </span>
    </div>
    <p class="card-text">{{ isEnglish? pricingData.description : pricingData.descriptionAr}}</p>
    <div class="card-price">
      <ng-container *ngIf="pricingData.price;else priceCustome ">
        <i class="card-sub  w-100">{{'global.starting_from' | translate}}</i>
        <h3 class="display-5">{{ pricingData.getMonthlyPrice()}} {{ pricingData.currency}} <sup class="text-small">
            /{{'global.month'| translate}}</sup></h3>
        <p class="card-text" *ngIf="pricingData.isMonthlyPrice"><i>{{'cms.subscription.billed_annually' | translate
            :{pricing: pricingData.getAnnualPrice()} }}</i></p>
      </ng-container>
      <ng-template #priceCustome>
        <h3> {{'global.custome' | translate}} </h3>
      </ng-template>
    </div>
    <!-- <ng-container *ngIf="pricingData.price;else changebutton ">
        <button class="btn my-3 py-3" (click)="openRegistration()" [ngClass]="isMid? 'btn-light text-primary':'btn-primary'">
          {{'cms.get_started' | translate}}
        </button>
      </ng-container>
      <ng-template #changebutton>
        <button class="btn my-3 py-3" (click)="openRegistration()" [ngClass]="isMid? 'btn-light text-primary':'btn-primary'">
          {{'global.connect_with_sale' | translate}}
        </button>
       </ng-template> -->
    <!-- <ul class="list-unstyled text-left mx-auto">
      <li *ngFor="let service of pricingData.children" class="d-flex align-items-center">
        <app-icon [icon]="!service.isRecommended ? 'circle-check' : 'circle-check-gray'" size="24px"
          class="mr-2"></app-icon>
        <span [ngClass]="!service.isRecommended ? '' :'text-muted' ">{{isEnglish? service.name : service.nameAr}}</span>
      </li>
    </ul> -->
  </div>
</div>